export default {
  web3: 'web3',
  bitcoin: 'bitcoin',
  bitcoincash: 'bitcoincash',
  ghost: 'ghost',
  next: 'next',
  coininfo: 'coininfo',
  storage: 'storage',
  sessionStorage: 'sessionStorage',
  swapsExplorer: 'swapsExplorer',
  metamask: 'metamask',
  getWeb3: 'getWeb3',
  isBinance: 'isBinance',
  web3bnb: 'web3bnb',
  getWeb3Bnb: 'getWeb3Bnb',
  web3Matic: 'web3Matic',
  getWeb3Matic: 'getWeb3Matic',
  web3Arbitrum: 'web3Arbitrum',
  getWeb3Arbitrum: 'getWeb3Arbitrum',
  isTest: 'isTest',
}
